import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot} from '@angular/router';
import {MsAuthService} from './service';
import {LocalStorage} from "ngx-webstorage";

@Injectable({
    providedIn: 'root'
})
export class MsAuthGuard implements CanActivate, CanActivateChild {
    private msAuthService = inject(MsAuthService);
    @LocalStorage()
    public previousRoute?: string;

    /* eslint-disable-next-line @typescript-eslint/no-unused-vars  */
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        await this.msAuthService.isReady();

        if (this.msAuthService.isAuthenticated()) {
            // make sure to clear this
            this.previousRoute = null;
            return true;
        } else {
            // remember the current route for redirection after authentication (this is a comma-separated string)
            this.previousRoute = route.url.toString();
            await this.msAuthService.redirectWhenNoAuthentication();
            return false;
        }
    }

    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

}
